export default class DeviceModel {
  name?: string | null;
  "device-brand-id"!: number | undefined;
  "device-category-id"?: number | undefined;
}
